import { S3Client } from '@aws-sdk/client-s3';

// Log AWS configuration
console.log('Initializing AWS S3 client...');
console.log('AWS Access Key ID:', import.meta.env.VITE_AWS_ACCESS_KEY_ID ? 'Provided' : 'Missing');
console.log('AWS Secret Access Key:', import.meta.env.VITE_AWS_SECRET_ACCESS_KEY ? 'Provided' : 'Missing');

// Initialize S3 client using environment variables
export const s3Client = new S3Client({
  region: 'us-east-1',
  credentials: {
    accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID || '',
    secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY || ''
  }
});

console.log('AWS S3 client initialized');